import { render } from "./UserCard.vue?vue&type=template&id=5ac54ad2&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=5ac54ad2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac54ad2"]])

export default __exports__